"use client";
import React, { useState } from "react";

export default function FaqMainOne({
  faqs = [],
  pillName = "Why Choose Us:",
  heading = "Your Trusted Partner for Scalable, Future-Ready Digital Solutions"
}) {
  const [activeFAQ, setActiveFAQ] = useState(0);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? 0 : index);
  };
  return (
    <section className="relative pt-16 mb-16 md:pb-[153px]">
      <div className="relative z-10 w-full">
        <div className="mx-auto theme-container px-4">
          <div className="relative flex items-center justify-center">
            <div className="grid grid-cols-6 xl:grid-cols-11 w-full relative z-10 gap-y-5 xl:gap-[118px]">
              <div className="col-span-6 xl:col-span-5 sm:pr-5">
              <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5 text-sm sm:text-base">
              {pillName}
          </h1>

          <h2 className="mt-5 mb-16 sm:mb-[64px] font-semibold text-34 sm:text-34 md:text-48 text-white">
          {heading}
          </h2>
          {/* <p className="text-paragraph mt-[30px] max-w-[424px] mb-[18px]">
            We’ve answered a few common ones to help you understand how we work
            and what you can expect.
          </p> */}
                <div className="relative w-full">
                  <img
                    className="w-full rounded-xl"
                    src="/assets/images/faq-1.png"
                    alt=""
                  />
                  <div className="w-10 px-2 sm:w-16 md:w-[100px] aspect-square rounded-lg bg-it-blue top-2 right-2 sm:-top-5 sm:-right-5 absolute flex justify-center items-center">
                  <svg width="64" height="52" viewBox="0 0 64 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M63.9995 24.7422L43.3809 45.3608L38.7624 40.7422L54.7624 24.7422L34.6387 4.61853L39.2572 -2.50837e-05L63.9995 24.7422Z" fill="#FEFEFE"/>
<path d="M0.000506687 27.0515L20.6191 6.4329L25.2376 11.0515L9.23762 27.0515L29.3613 47.1752L24.7428 51.7937L0.000506687 27.0515Z" fill="#FEFEFE"/>
<path d="M51.3 24.9071L37.1144 39.0927L32.9907 34.969L43.0526 24.9071L22.599 4.45353L26.7227 0.329816L51.3 24.9071Z" fill="#FEFEFE"/>
<path d="M12.702 26.8866L26.8875 12.701L31.0112 16.8247L20.9494 26.8866L41.403 47.3402L37.2793 51.4639L12.702 26.8866Z" fill="#FEFEFE"/>
</svg>

                  </div>
                </div>
              </div>
              <div className="col-span-6 mt-5 md:mt-0">
          <div data-aos="fade-up" className="flex flex-col gap-2.5 w-full">
            {/* <!-- faq single start  --> */}
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`py-4 sm:py-5 px-3 sm:px-2 md:px-[30px] w-full rounded-[10px] h7-faq-toggler overflow-hidden transition-all duration-300 max-h-fit h-fit border border-blue-seo/15 ${
                  activeFAQ === index ? "text-blue-seo  bg-blue-seo/10 " : ""
                }`}
                name="faq-1"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex items-center justify-between w-full pointer-events-none h-fit">
                  <h1
                    className={`font-semibold text-16 sm:text-18 text-blue-seo ${
                      activeFAQ === index ? "text-chip" : "text-white"
                    }`}
                  >
                    {faq.question}
                  </h1>

                  <svg
                    style={{
                      rotate: activeFAQ === index ? "180deg" : "0deg",
                      transition: "rotate 0.3s ease",
                    }}
                    width="19"
                    height="10"
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="#3674FB"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {activeFAQ === index && (
                  <p className="mt-3.5 text-paragraph pointer-events-none h-fit text-sm sm:text-base">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
